import { useQuery } from "@tanstack/react-query";
import { groomingSharedAgendaApi } from "@/lib/api/grooming-shared-agenda";
import { groomingRootKey, retryTransientOnce } from "@/hooks/queries/use-work-items";

/**
 * The size-free shared agenda (PKG-PM-C, epic PI-SPEC-SW-E291, feature
 * PI-SPEC-SW-1491). Under the grooming root key, so anything that refreshes
 * every grooming read refreshes it too, but not under the batch key: its
 * shape is not a batch's, and it must never be mixed up with the sized read.
 */
export const sharedAgendaKeys = {
  all: [...groomingRootKey, "shared-agenda"] as const,
  agenda: (batchId: string) => [...sharedAgendaKeys.all, batchId] as const,
};

/** The agenda behind a "Share agenda" link, for any signed-in person. */
export function useSharedAgenda(batchId: string | undefined) {
  return useQuery({
    queryKey: sharedAgendaKeys.agenda(batchId ?? ""),
    queryFn: () => groomingSharedAgendaApi.get(batchId ?? ""),
    select: (response) => response.data,
    enabled: Boolean(batchId),
    retry: retryTransientOnce,
  });
}
